export const SettingsIcon = (): JSX.Element => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="currentColor"
		fillRule="evenodd"
	>
		<path d="M10.18 4.11L10.54 1.60A10.50 10.50 0 0 1 13.46 1.60L13.82 4.11A8.10 8.10 0 0 1 16.29 5.13L18.32 3.61A10.50 10.50 0 0 1 20.39 5.68L18.87 7.71A8.10 8.10 0 0 1 19.89 10.18L22.40 10.54A10.50 10.50 0 0 1 22.40 13.46L19.89 13.82A8.10 8.10 0 0 1 18.87 16.29L20.39 18.32A10.50 10.50 0 0 1 18.32 20.39L16.29 18.87A8.10 8.10 0 0 1 13.82 19.89L13.46 22.40A10.50 10.50 0 0 1 10.54 22.40L10.18 19.89A8.10 8.10 0 0 1 7.71 18.87L5.68 20.39A10.50 10.50 0 0 1 3.61 18.32L5.13 16.29A8.10 8.10 0 0 1 4.11 13.82L1.60 13.46A10.50 10.50 0 0 1 1.60 10.54L4.11 10.18A8.10 8.10 0 0 1 5.13 7.71L3.61 5.68A10.50 10.50 0 0 1 5.68 3.61L7.71 5.13A8.10 8.10 0 0 1 10.18 4.11ZM8.60 12a3.40 3.40 0 1 0 6.80 0a3.40 3.40 0 1 0-6.80 0Z" />
	</svg>
)
